// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { DeletePortfolioRequestToJSON, } from '../models';
/**
 * delete portfolios for selected portfolio Ids
 * Delete portfolios
 */
export function deletePortfoliosRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/portfolios` + queryString,
        meta,
        update: requestConfig.update || {
            PortfoliosDelete: (prevValue, transformedValue) => {
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            PortfoliosDelete: (prevValue) => {
            }
        },
        rollback: requestConfig.rollback || {
            PortfoliosDelete: (initialValue, currentValue) => {
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'DELETE',
            headers: headerParameters,
        },
        body: DeletePortfolioRequestToJSON(requestParameters.deletePortfolioRequest),
    };
    config.queryKey = requestConfig.queryKey || `DeletePortfolios-${objectToHash(requestParameters)}`;
    return config;
}
/**
* delete portfolios for selected portfolio Ids
* Delete portfolios
*/
export function deletePortfolios(requestParameters, requestConfig) {
    return deletePortfoliosRaw(requestParameters, requestConfig);
}
